var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hotReqsType',{attrs:{"baseUrlpath":_vm.baseUrlpath}})
}
var staticRenderFns = []

export { render, staticRenderFns }